import { Expose, Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

// Model

export class BankAccountLiteModel extends CommonModel {
  code: string;
  name: string;
  description?: string | null;

  @Type(() => Number)
  balance: number;

  @Expose({ name: 'account_number' })
  accountNumber: string;
}

export class BankAccountModel extends BankAccountLiteModel {}

// Input

export type getBankAccountsInput = {
  params: CommonParamInput;
};

export type getBankAccountInput = {
  id: string;
};

export type BankAccountMutationInput = {
  code: string;
  name: string;
  description?: string | null;
  accountNumber: string;
};

export type BankAccountUpdateInput = {
  bankAccountId: string;
  body: BankAccountMutationInput;
};

export type BankAccountDeleteInput = {
  bankAccountId: string;
};
